export const requireResource = resource => require('@/../../resources/' + resource); 

export const requireImg   = img => requireResource('img/' + img);
export const requireJson  = json => requireResource('json/' + json);
export const requireAudio = audio => requireResource('audio/' + audio);

export default {requireResource, requireImg, requireJson, requireAudio};